import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { subscriptionsInformation } from '../../../../redux/slices/subscriptionsSlice';
import { VM } from '../../../../viewmodel/VM';
import { useLanguage, useTranslate } from '../../../context/languageContext';
import SubscribeLine from './manageNotifications/SubscribeLine';
import SubscribeNews from './manageNotifications/SubscribeNews';
import SubscribeStation from './manageNotifications/SubscribeStation';
import { agencyInformation } from '../../../../redux/slices/agencySlice';
import { linesState } from '../../../../redux/slices/lineSlice';
import { typologiesInformation } from '../../../../redux/slices/typologySlice';
import SubscribeTypologyNews from './manageNotifications/SubscribeTypologyNews';
import { markersInformation } from '../../../../redux/slices/markersSlice';

export default function TrafficAlertsScreen(props: any) {
  const [selected, setSelected] = useState(0);
  const agencyInfo = useSelector(agencyInformation);
  const language = useLanguage();
  const t = useTranslate();
  const allLines = useSelector(linesState);
  const allStops = useSelector(markersInformation).stops;

  const subscriptions = useSelector(subscriptionsInformation);
  const typologies = useSelector(typologiesInformation);

  useEffect(() => {
    async function fetchData() {}
    fetchData();
  }, []);

  const renderSelected = () => {
    switch (selected) {
      case 0:
        return renderStations();
      case 1:
        return renderLines();
      case 2:
        return renderNews();
      default:
        return renderStations();
    }
  };

  const renderStations = () => {
    let res = [];
    for (let stopId in subscriptions.stops) {
      let stop: any = allStops.find((foundStop: any) => foundStop.id === subscriptions.stops[stopId]);
      if(stop)
        res.push(<SubscribeStation key={stop?.id} stop={stop} />);
    }
    if (!res.length)
      return (
        <div className={'description padding10'} style={{ textAlign: 'left' }}>
          {t('subscriptions_empty_stopsMessage')}
        </div>
      );
    return res;
  };

  const renderLines = () => {
    let res = [];
    for (let lineId in subscriptions.lines) {
      let line: any = allLines?.find((element: any) => element?.id === subscriptions.lines[lineId]);
      if (line) {
        res.push(<SubscribeLine key={line.id} line={line} />);
      }
    }
    if (!res.length)
      return (
        <div className={'description padding10'} style={{ textAlign: 'left' }}>
          {t('subscriptions_empty_linesMessage')}
        </div>
      );
    return res;
  };

  // parece que el código no es lo que hay en producción, comento este método y pongo lo que hay en producción ya que el que tenemos da error
  // const renderNews = () => {
  //   let res = [];
  //   for (let noticeId in subscriptions.agencyNotices) {
  //     if (subscriptions.agencyNotices.indexOf(subscriptions.agencyNotices[noticeId] as never) >= 0) {
  //       let notice: any = agencyInfo.agenciesTransport[subscriptions.agencyNotices[noticeId]];
        
  //       if(notice)
  //         res.push(<SubscribeNews key={notice?.id} notice={notice} />);
  //     }
  //   }
  //   if (!res.length)
  //     return (
  //       <div className={'description padding10'} style={{ textAlign: 'left' }}>
  //         {t('subscriptions_empty_newsMessage')}
  //       </div>
  //     );
  //   return res;
  // };

  const renderNews = () => {
    let res = [];
    for (let noticeId in subscriptions.agencyNotices) {
      if (subscriptions.agencyNotices.indexOf(subscriptions.agencyNotices[noticeId] as never) >= 0) {
        let notice: any = agencyInfo.dataOrigin.find((element: any) => element.id === subscriptions.agencyNotices[noticeId]);
        const agencyFound: any = agencyInfo.agenciesTransport.find((element: any) => element.id === notice?.agencyId);
        
        if(notice && agencyFound) {
          res.push(<SubscribeNews key={`agency-${agencyFound?.id}`} notice={agencyFound} />);
        }
      }
    }
    
    // Parte para typologyNotices
    for(let typology of typologies) {
      if(subscriptions.typologyNotices.indexOf(typology.id as never) >= 0) {
        res.push(<SubscribeTypologyNews key={`typology-${typology.id}`} notice={typology} />);
      }
    }
    
    if (!res.length)
      return (
        <div className={'description padding10'} style={{ textAlign: 'left' }}>
          {t('subscriptions_empty_newsMessage')}
        </div>
      );
    return res;
  };

  return (
    <div className={'account-child-header'} style={{ width: '100%' }}>
      <div className={'account-support-header'}>
        <div className={'title'}>{t('trafficAlerts')}</div>
        <div className={'row'} style={{ overflowX: 'scroll' }}>
          <div
            className={selected == 0 ? 'tabSelected' : 'tabSelector'}
            onClick={() => setSelected(0)}>
            {t('stops')}
          </div>
          <div
            className={selected == 1 ? 'tabSelected' : 'tabSelector'}
            onClick={() => setSelected(1)}>
            {t('lines')}
          </div>
          <div
            className={selected == 2 ? 'tabSelected' : 'tabSelector'}
            onClick={() => setSelected(2)}>
            {t('news')}
          </div>
        </div>
      </div>
      <div className={'account-child'} style={{ maxHeight: 414, minHeight: 414 }}>
        {renderSelected()}
      </div>
    </div>
  );
}
